import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import isEmpty from 'lodash/isEmpty';
import queryString from 'query-string';
import React, { useMemo } from 'react';

// Provider Props
interface QueriesProviderProps {
    children: React.ReactNode;
    page?: Page | null;
}

// Provider Component
export const QueriesProvider: React.FC<QueriesProviderProps> = ({ children, page }) => {
    const queryClient = useMemo(() => {
        const client = new QueryClient({
            defaultOptions: {
                queries: {
                    staleTime: Infinity,
                },
            },
        });

        if (page !== null) {
            const query =
                window && !isEmpty(window.location.search)
                    ? queryString.parse(window.location.search, {
                          arrayFormat: 'bracket',
                      })
                    : null;
            client.setQueryData(['pages', page.url, query], page);
        }
        return client;
    }, [page]);

    return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
